import React from "react";
import classes from "./categorySection.module.css";
import { useNavigate } from "react-router-dom";

const CategorySection = ({ categories }) => {
  const navigate = useNavigate();

  const handleStartCompeting = () => {
    navigate("/artist-next-door-arena/compete");
  };

  return (
    <section className={classes.categorySection} id="categories">
      <div className={classes.sectionHeader}>
        <h2 className={classes.sectionTitle}>
          Performance <span className={classes.highlight}>Categories</span>
        </h2>
        <p className={classes.sectionDescription}>
          Show your talent in various categories and compete with the best
          artists across India
        </p>
      </div>

      <div className={classes.categoriesGrid}>
        {categories.map((category) => (
          <div
            key={category.id}
            className={classes.categoryCard}
            style={{ "--category-color": category.color }}
          >
            <div className={classes.categoryIcon}>{category.icon}</div>
            <h3 className={classes.categoryName}>{category.name}</h3>
            <p className={classes.categoryDescription}>
              Showcase your {category.name.toLowerCase()} talent and win amazing
              prizes!
            </p>
            <button
              className={classes.categoryButton}
              onClick={handleStartCompeting}
            >
              Compete Now
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategorySection;
